import React, { useState } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import RfqDashboard from "../../../../ecommerce/products/new-product/crm/rfq/RfqDashboard";
import GlobalAgentDashboard from "../../../../ecommerce/products/new-product/crm/Global Agent/GlobalAgentDashboard";
import ServiceProviderDashboard from "../../../../ecommerce/products/new-product/crm/Service Provider/ServiceProviderDashboard";
import OceanDashboard from "../../../../ecommerce/products/new-product/OceanTMS/OceanDashboard";
import RoadDashboard from "../../../../ecommerce/products/new-product/Shipment/RoadDashboard";
import QuotingIntelligenceHome from "../../../../ecommerce/products/new-product/QuotingTool/QuotingDashboard";
import FullIntegratedDashboard from "../../../../ecommerce/products/new-product/crm/opportunity/SalesRepDashboard";
import MeetingDashboard from "../../../../ecommerce/products/new-product/crm/opportunity/MeetingDashboard";
import CustomerDashboard from "../../../../ecommerce/products/new-product/crm/opportunity/CustomerDashboard";
import SalesDashboard from "../../../../ecommerce/products/new-product/crm/opportunity/SalesDashboard";
import AirDashboard from "../../../../ecommerce/products/new-product/AirTMS/AirDashboard";

function SalesByCountry() {
    const [activeTab, setActiveTab] = useState(0);
    const [activeTmsTab, setActiveTmsTab] = useState(0);
    const [activeCrmTab, setActiveCrmTab] = useState(0);
    const tmsTabs = [
        {
            label: "ROAD",
            fullLabel: "Road TMS Dashboard",
            icon: "local_shipping",
            description: "Road transportation, shipment tracking and operational metrics.",
            component: <RoadDashboard embedded />,
        },
        {
            label: "OCEAN",
            fullLabel: "Ocean TMS Dashboard",
            icon: "directions_boat",
            description: "Ocean freight operations, shipments and performance overview.",
            component: <OceanDashboard embedded />,
        },
        {
            label: "AIR",
            fullLabel: "Air TMS Dashboard",
            icon: "flight",
            description: "Air freight operations, shipments and performance overview.",
            component: <AirDashboard embedded />,
        }
    ];

    const activeTmsDashboard = tmsTabs[activeTmsTab];
    const crmTabs = [
        {
            label: "Product",
            fullLabel: "Product Dashboard",
            icon: "analytics",
            description: "Sales performance, opportunities and transport type analysis.",
            component: <SalesDashboard embedded />,
        },
        {
            label: "Customer",
            fullLabel: "Customer Dashboard",
            icon: "groups",
            description: "Customer statistics, opportunity distribution and revenue analysis.",
            component: <CustomerDashboard embedded />,
        },
        {
            label: "Sales",
            fullLabel: "Sales Dashboard",
            icon: "dashboard_customize",
            description: "Integrated CRM overview for opportunities, meetings and sales reps.",
            component: <FullIntegratedDashboard embedded />,
        },
        {
            label: "Meeting",
            fullLabel: "Meeting Dashboard",
            icon: "event_available",
            description: "Meeting health, follow-up status and customer engagement tracking.",
            component: <MeetingDashboard embedded />,
        },
    ];

    const activeCrmDashboard = crmTabs[activeCrmTab];
    const dashboardTabs = [
        {
            label: "TMS",
            fullLabel: activeTmsDashboard.fullLabel,
            icon: "route",
            description: activeTmsDashboard.description,
            component: (
                <MDBox>
                    <MDBox
                        sx={{
                            mb: 2,
                            p: 1,
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            border: "1px solid rgba(148,163,184,0.25)",
                            boxShadow: "none",
                        }}
                    >
                        <Tabs
                            value={activeTmsTab}
                            onChange={(event, newValue) => setActiveTmsTab(newValue)}
                            variant="fullWidth"
                            sx={{
                                minHeight: 54,
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    minHeight: 62,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: "1rem",
                                    borderRadius: "10px",
                                    mx: 0.4,
                                    px: 2.5,
                                    color: "#64748b",
                                    transition: "all 0.25s ease",
                                },
                                "& .MuiTab-root:hover": {
                                    backgroundColor: "rgba(59,130,246,0.08)",
                                    color: "#1D4ED8",
                                },
                                "& .Mui-selected": {
                                    color: "#ffffff !important",
                                    background:
                                        "#2563EB",
                                    boxShadow: "0 8px 18px rgba(37,99,235,0.28)",
                                },
                            }}
                        >
                            {tmsTabs.map((tab) => (
                                <Tab
                                    key={tab.label}
                                    label={
                                        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                            <Icon fontSize="small">{tab.icon}</Icon>
                                            <span>{tab.label}</span>
                                        </Box>
                                    }
                                />
                            ))}
                        </Tabs>
                    </MDBox>

                    {activeTmsDashboard.component}
                </MDBox>
            ),
        },
        {
            label: "RFQ",
            fullLabel: "RFQ Dashboard",
            icon: "request_quote",
            description: "Manage customer requests and quotation flow.",
            component: <RfqDashboard embedded />,
        },
        {
            label: "Global Partner",
            fullLabel: "Global Partner Dashboard",
            icon: "public",
            description: "Monitor global agents and partner relationships.",
            component: <GlobalAgentDashboard embedded />,
        },
        {
            label: "Supplier Management",
            fullLabel: "Supplier Management Dashboard",
            icon: "business",
            description: "Manage suppliers, service providers and operational partners.",
            component: <ServiceProviderDashboard embedded />,
        },
        {
            label: "Quoting Management",
            fullLabel: "Quoting Management Dashboard",
            icon: "price_check",
            description: "Track quote performance, win rate, revenue, profit and quotation analytics.",
            component: <QuotingIntelligenceHome embedded />,
        },
        {
            label: "CRM",
            fullLabel: activeCrmDashboard.fullLabel,
            icon: "groups",
            description: activeCrmDashboard.description,
            component: (
                <MDBox>
                    <MDBox
                        sx={{
                            mb: 2,
                            p: 1,
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            border: "1px solid rgba(148,163,184,0.25)",
                            boxShadow: "none",
                        }}
                    >
                        <Tabs
                            value={activeCrmTab}
                            onChange={(event, newValue) => setActiveCrmTab(newValue)}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            sx={{
                                minHeight: 54,
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    minHeight: 62,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: "1rem",
                                    borderRadius: "10px",
                                    mx: 0.4,
                                    px: 2.5,
                                    color: "#64748b",
                                    transition: "all 0.25s ease",
                                },
                                "& .MuiTab-root:hover": {
                                    backgroundColor: "rgba(59,130,246,0.08)",
                                    color: "#1D4ED8",
                                },
                                "& .Mui-selected": {
                                    color: "#ffffff !important",
                                    background:
                                        "#2563EB",
                                    boxShadow: "0 8px 18px rgba(37,99,235,0.28)",
                                },
                            }}
                        >
                            {crmTabs.map((tab) => (
                                <Tab
                                    key={tab.label}
                                    label={
                                        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                                            <Icon fontSize="small">{tab.icon}</Icon>
                                            <span>{tab.label}</span>
                                        </Box>
                                    }
                                />
                            ))}
                        </Tabs>
                    </MDBox>

                    {activeCrmDashboard.component}
                </MDBox>
            ),
        },
    ];

    const activeDashboard = dashboardTabs[activeTab] || dashboardTabs[0];

    return (
        <MDBox>
            <Card
                sx={{
                    mt: 3,
                    borderRadius: "10px",
                    overflow: "hidden",
                    backgroundColor: "#f8fafc",
                    boxShadow: "none",
                    border: "1px solid rgba(148,163,184,0.20)",
                }}
            >
                <MDBox
                    sx={{
                        p: { xs: 2, md: 3 },
                        background:
                            "radial-gradient(circle at top left, rgba(37,99,235,0.16), transparent 30%), #ffffff",
                        borderBottom: "1px solid rgba(148,163,184,0.22)",
                    }}
                >
                    <MDBox mb={2.5}>
                        <MDBox display="flex" alignItems="center" gap={1.2} mb={1}>
                            <MDBox
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background:
                                        "#2563EB",
                                    boxShadow: "0 10px 22px rgba(37,99,235,0.28)",
                                    flexShrink: 0,
                                }}
                            >
                                <Icon sx={{ color: "#ffffff" }}>dashboard</Icon>
                            </MDBox>

                            <MDBox flex={1} minWidth={0}>
                                <MDTypography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 950,
                                        color: "#0f172a",
                                        letterSpacing: "-0.5px",
                                        lineHeight: 1.15,
                                    }}
                                >
                                    Management Dashboards
                                </MDTypography>

                                <MDTypography
                                    variant="body2"
                                    sx={{
                                        color: "#64748b",
                                        fontWeight: 500,
                                    }}
                                >
                                    Centralized operational control panel for commercial and logistics management dashboards.
                                </MDTypography>
                            </MDBox>

                            <MDBox
                                display="flex"
                                alignItems="center"
                                gap={0.8}
                                px={1.5}
                                py={0.7}
                                sx={{
                                    borderRadius: 999,
                                    backgroundColor: "rgba(22,163,74,0.08)",
                                    border: "1px solid rgba(22,163,74,0.22)",
                                    flexShrink: 0,
                                }}
                            >
                                <MDBox
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        backgroundColor: "#16a34a",
                                        boxShadow: "0 0 0 3px rgba(22,163,74,0.18)",
                                    }}
                                />
                                <MDTypography
                                    variant="caption"
                                    sx={{ color: "#15803d", fontWeight: 700 }}
                                >
                                    Live
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    </MDBox>

                    <MDBox
                        sx={{
                            p: 1,
                            borderRadius: "10px",
                            backgroundColor: "rgba(255,255,255,0.78)",
                            border: "1px solid rgba(148,163,184,0.22)",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        <Tabs
                            value={activeTab}
                            onChange={(event, newValue) => setActiveTab(newValue)}
                            variant="fullWidth"
                            sx={{
                                minHeight: 58,
                                "& .MuiTabs-flexContainer": {
                                    gap: 0.5,
                                },
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    minHeight: 58,
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: "1rem",
                                    borderRadius: "10px",
                                    px: { xs: 1, md: 2.5 },
                                    color: "#64748b",
                                    transition: "all 0.25s ease",
                                },
                                "& .MuiTab-root:hover": {
                                    backgroundColor: "rgba(37,99,235,0.08)",
                                    color: "#2563EB",
                                },
                                "& .Mui-selected": {
                                    color: "#ffffff !important",
                                    background:
                                        "#2563EB",
                                    boxShadow: "0 10px 22px rgba(37,99,235,0.25)",
                                },
                            }}
                        >
                            {dashboardTabs.map((tab) => (
                                <Tab
                                    key={tab.label}
                                    label={
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <Icon fontSize="small">{tab.icon}</Icon>
                                            <span>{tab.label}</span>
                                        </Box>
                                    }
                                />
                            ))}
                        </Tabs>
                    </MDBox>
                </MDBox>

                <MDBox
                    sx={{
                        p: { xs: 2, md: 2.5 },
                        backgroundColor: "#f8fafc",
                    }}
                >
                    <MDBox
                        sx={{
                            mb: 2,
                            p: 2,
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            border: "1px solid rgba(148,163,184,0.20)",
                            boxShadow: "none",
                        }}
                    >
                        <MDBox display="flex" alignItems="center" gap={1.2}>
                            <Icon sx={{ color: "#2563EB" }}>{activeDashboard.icon}</Icon>

                            <MDBox>
                                <MDTypography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#0f172a",
                                        lineHeight: 1.2,
                                    }}
                                >
                                    {activeDashboard.fullLabel}
                                </MDTypography>

                                <MDTypography
                                    variant="body2"
                                    sx={{
                                        color: "#64748b",
                                        fontWeight: 500,
                                    }}
                                >
                                    {activeDashboard.description}
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    </MDBox>

                    <Divider sx={{ mb: 2 }} />

                    <MDBox
                        sx={{
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            border: "1px solid rgba(148,163,184,0.18)",
                            boxShadow: "none",
                            p: { xs: 1.5, md: 2 },
                        }}
                    >
                        {activeDashboard.component}
                    </MDBox>
                </MDBox>
            </Card>
        </MDBox>
    );
}

export default SalesByCountry;